import * as angular from 'angular';
import './styling.scss';
import * as template from './template.html';
import { StateService } from '@uirouter/angularjs';
import * as _ from 'lodash';
import {
    getNavigationStates,
    getNavigationStatesWithSmartHome,
    NavigationOption,
    NavigationOptions
} from 'components/navigation/shared/states';
import { get } from 'lodash';
import { CurrentUserService } from 'services/currentUser';
import { ExperimentsService } from 'services/experiments';
import { providerToExperimentFlagMap } from 'utilities/experiments';

const module = angular.module('page-selector', []);

interface PageSelectorController extends angular.IStrictController {
    active: boolean;
    toggle(): void;
    onBlur(): void;
    close(): void;
    select(): void;
    pages: NavigationOptions;
    currentPage: NavigationOption;
    isVisible: boolean;
}

module.component('pageSelector', {
    template: template,
    controller: function(
        this: PageSelectorController,
        $timeout,
        $state: StateService,
        $stateParams: PolicyStateParams,
        currentUserService: CurrentUserService,
        experimentsService: ExperimentsService
    ) {
        'ngInject';

        this.$onInit = () => {
            this.isVisible = !!$stateParams.policyIndex;

            currentUserService.getCustomerPolicyInfoByIndex($stateParams.policyIndex).then((policyInfo) => {
                const smartHomeKits = get(policyInfo, 'smart_home.state_summary.kit_details') as Array<SmartHomeKit>;

                /*
                    smart home kits are ordered by date created. The last kit should be the one the customer
                    most recently chose which will be used to render the smart home page UI.
                 */
                const lastSmartHomeKit = smartHomeKits ? smartHomeKits[smartHomeKits.length - 1] : null;

                const isSmartHomePageExperimentEnabledForProvider = lastSmartHomeKit
                    ? experimentsService.isExperimentEnabled(providerToExperimentFlagMap[lastSmartHomeKit.provider])
                    : false;

                if (isSmartHomePageExperimentEnabledForProvider) {
                    this.pages = getNavigationStatesWithSmartHome($stateParams.policyIndex);
                } else {
                    this.pages = getNavigationStates($stateParams.policyIndex);
                }

                const currentPageName = $state.current.name || '';

                const currentPage = _.find(this.pages, (state: NavigationOption) => {
                    return state.sref.toLowerCase().indexOf(currentPageName) > -1;
                });

                if (currentPage) {
                    this.currentPage = currentPage;
                }
            });
        };

        this.toggle = () => {
            this.active = !this.active;
        };

        this.close = () => {
            this.active = false;
        };

        this.select = () => {
            $timeout(() => {
                this.close();
            });
        };

        this.onBlur = () => {
            $timeout(() => {
                const focusedElement = document.activeElement;

                if (
                    !focusedElement ||
                    (!focusedElement.classList.contains('page') &&
                        !focusedElement.classList.contains('dropdown-list-item') &&
                        !focusedElement.classList.contains('dropdown'))
                ) {
                    this.close();
                }
            });
        };
    }
});

export { module };
